import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { patch } from '../../../redux/api';
import { nuc } from '../../../utils';
import { getQueryKey as getRevisionQueryKey } from '../revisions/useRevision';
import type { UpdateProjectCorrectionRequestProject } from '../../../../typings/api';

const upsertCorrection = async ({
  correctionData,
  revisionLocator,
}: {
  correctionData: Partial<UpdateProjectCorrectionRequestProject>;
  revisionLocator: string;
}): Promise<void> => {
  await patch(`/api/v2/revisions/${nuc(revisionLocator)}/correction/metadata`, { data: correctionData });
};

/**
 * Hook for upserting metadata correction.
 */
export default function useCorrectDependencyMetadata(dependencyLocator: string) {
  return useToastedMutation({
    mutationFn: upsertCorrection,
    successToastMessage: 'Correction saved successfully',
    errorToastMessage: 'Failed to save correction',
    onSuccess: () => {
      // Wildcard invalidation for the dependency in both the project and release group scopes.
      // This is important in case the dependency is in both scopes and the user has both scopes open,
      // such as in two tabs. We don't want to end up in an inconsistent state.
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return key.includes('dependencies') && key.includes(dependencyLocator);
        },
      });
      queryClient.invalidateQueries({
        queryKey: getRevisionQueryKey(dependencyLocator),
      });
    },
  });
}
